import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="getcalendarevents">
                1.&nbsp;<span className="material-symbols-outlined">calendar_month</span>&nbsp;{translate('getcalendarevents')}
            </Typography>
            <p><strong>{translate('getcalendarevents')}</strong> is an action to retrieve appointment information registered in Google Calendar managed by your account.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$calendarEvents_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Google Calendar connection used to identify the Google Calendar account (see <Box component={Link} to="/control-center/documentation/connections/calendar">here</Box> for making connections).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('calendarid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the ID of Google Calendar.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('from')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Is start time (YYYY-MM-DDThh:mm+00:00).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('to')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is end time (YYYY-MM-DDThh:mm+00:00).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('summary')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the search keyword in the summary.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('descriptions')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the search keyword in the descriptions.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('limit')}</td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is the maximum amount of data returned on request (up to 2500).</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$calendarEvents_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gcalendar-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('calendarid')}</span>
                            <div>john.doe@example.com</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('from')}</span>
                            <div>2022-12-01T00:00:00+07:00</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('to')}</span>
                            <div>2022-12-31T23:59:59+07:00</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <pre>
                                {JSON.stringify(
                                    {
                                        "kind": "calendar#events", 
                                        "etag": "\"p33ccffukl7kfc0g\"", 
                                        "summary": "rpa@example.com", 
                                        "updated": "2022-12-28T07:53:10.999Z",
                                        "timeZone": "Asia/Ho_Chi_Minh",
                                        "accessRole": "reader",
                                        "defaultReminders": [],
                                        "nextPageToken": "EjYKKzB2aDQ5dWwyZG0xMDAzbXFnZWdnYjY2aHI4XzIw",
                                        "items": [
                                            {
                                            "kind":"calendar # event",
                                            "etag":"\"3149289245102000\"",
                                            "id":"0vh49ul2dm1003mqgeggb66hr8_20220803T013000Z",
                                            "status":"confirmed",
                                            "htmlLink":"https://www.google.com/calendar/event?eid=MHZoNDl1bDJkbTEwMDNtcWdlZ2diNjZocjhfMjAyMjA4MDNUMDEzMDAwWiB0aF9uZ3V5ZW5AdmlzaW9uLW5ldC5jby5qcA", 
                                            "created" : "2022-12-28T07:53:10.999Z", 
                                            "creator": {
                                                "email": "rpa@example.com", 
                                                "self": true
                                            }, 
                                            "organizer": {
                                                "email": "rpa@example.com", 
                                                "self": true
                                            }, 
                                            "start": {
                                                "dateTime": "2022-12-01T00:00:00+07:00", 
                                                "timeZone": "Asia/Ho_Chi_Minh"
                                            }, 
                                            "end": {
                                                "dateTime": "2022-12-31T23:59:59+07:00",
                                                "timeZone": "Asia/Ho_Chi_Minh"
                                            },
                                            "recurringEventId": "0vh49ul2dm1003mqgeggb66hr8",
                                            "originalStartTime": {
                                                "dateTime": "2022-12-01T00:00:00+07:00",
                                                "timeZone": "Asia/Ho_Chi_Minh"
                                            },
                                            "iCalUID":"0vh49ul2dm1003mqgeggb66hr8@google.com", 
                                            "sequence": 1, 
                                            "reminders": {
                                                "useDefault": true
                                            },
                                            "eventType": "default"
                                            }
                                        ]
                                    }, null, 2)}
                            </pre>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="createcalendarevent">
                2.&nbsp;<span className="material-symbols-outlined">edit_calendar</span>&nbsp;{translate('createcalendarevent')}
            </Typography>
            <p><strong>{translate('createcalendarevent')}</strong> is an action that creates a new appointment.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$newCalendarEvent_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Google Calendar connection used to identify the Google Calendar account (see <Box component={Link} to="/control-center/documentation/connections/calendar">here</Box> for making connections).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('from')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Is start time (YYYY-MM-DDThh:mm+00:00).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('to')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is end time (YYYY-MM-DDThh:mm+00:00).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('summary')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the summary.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('descriptions')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the descriptions.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('attendees')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Add participants to the appointment.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newCalendarEvent_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gcalendar-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('from')}</span>
                            <div>2022-12-01T00:00:00+07:00</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('to')}</span>
                            <div>2022-12-31T23:59:59+07:00</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('summary')}</span>
                            <div>Meeting</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('attendees')}</span>
                            <div>jane.doe@example.com</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <pre>
                                {JSON.stringify(
                                    {
                                        "kind": "calendar#event",
                                        "etag": "\"3296909014752000\"",
                                        "id": "gld9fnvnhi84o0s1np8gagtu68",
                                        "status": "confirmed",
                                        "htmlLink": "https://www.google.com/calendar/event?eid=Z2xkOWZudm5oaTg0bzBzMW5wOGdhZ3R1Njgga19nYXJjaWFAdmlzaW9uLW5ldC5jby5qcA",
                                        "created": "2022-12-28T07:53:10.999Z",
                                        "summary": "Meeting",
                                        "description": "Meeting with Mr.jane.",
                                        "creator": {
                                            "email ": "rpa@example.com",
                                            "self ": true
                                        },
                                        "organizer": {
                                            "email ": "rpa@example.com",
                                            "self": true
                                        },
                                        "start": {
                                            "dateTime": "2022-12-01T00:00:00+07:00",
                                            "timeZone": "Asia/Ho_Chi_Minh"
                                        },
                                        "end": {
                                            "dateTime": "2022-12-31T23:59:59+07:00",
                                            "timeZone": "Asia/Ho_Chi_Minh"
                                        },
                                        "iCalUID": "gld9fnvnhi84o0s1np8gagtu68@google.com",
                                        "sequence": 0,
                                        "attendees": [
                                            {
                                            "email ": "jane.doe@example.com",
                                            "responseStatus": "needsAction"
                                            }
                                        ],
                                        "reminders ": {
                                            "useDefault": true
                                        },
                                        "eventType": "default"
                                    }, null, 2)}
                            </pre>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="removecalendarevent">
                3.&nbsp;<span className="material-symbols-outlined">event_busy</span>&nbsp;{translate('removecalendarevent')}
            </Typography>
            <p><strong>{translate('removecalendarevent')}</strong> is an act of canceling appointments.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Google Calendar connection used to identify the Google Calendar account (see <Box component={Link} to="/control-center/documentation/connections/calendar">here</Box> for making connections).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('eventid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the appointment ID.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gcalendar-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('eventid')}</span>
                            <div>gld9fnvnhi84o0s1np8gagtu68</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);